import { useEffect } from 'react';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';
import { Button } from '@/components/ui';
import { logger } from '@/lib/logger';

export function RouteErrorFallback() {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    if (isRouteErrorResponse(error)) {
      logger.error('[RouteError]', error.status, error.statusText, error.data);
    } else if (error instanceof Error) {
      logger.error('[RouteError]', error);
    } else {
      logger.error('[RouteError]', String(error));
    }
  }, [error]);

  const message =
    isRouteErrorResponse(error) ? error.statusText || 'Something went wrong' : 'Something went wrong';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">Something went wrong</h1>
        <p className="text-slate-600 dark:text-slate-400 mb-6">{message}</p>
        <Button variant="primary" onClick={() => navigate(0)}>
          Try Again
        </Button>
      </div>
    </div>
  );
}
